<div class="ds ds-dialog is-complex position-dialog">
	<!-- Cabecera -->
	<div class="ds-dialog__head">
		<span class="ds-dialog__icon"><mat-icon>{{ isGeneral ? "public" : "label" }}</mat-icon></span>
		<div class="ds-dialog__titles">
			<h2 class="ds-dialog__title">{{ (isNew ? "positions.editor.new" : "positions.editor.edit") | translate }}</h2>
			<p class="ds-dialog__sub">
				<ng-container *ngIf="isGeneral">{{ "positions.dialog.subGeneral" | translate }}</ng-container>
				<ng-container *ngIf="!isGeneral">{{ "positions.dialog.subFuncion" | translate }}<span *ngIf="funcionAgregada"> · <b>{{ funcionAgregada }}</b></span></ng-container>
			</p>
		</div>
		<button type="button" class="ds-dialog__x" (click)="close()" [attr.aria-label]="'common.close' | translate"><mat-icon>close</mat-icon></button>
	</div>

	<!-- Cuerpo -->
	<div class="ds-dialog__body">
		<div class="ds-dialog__note">
			<mat-icon>info</mat-icon>
			<div class="ds-dialog__note-tx">
				<p>{{ (isGeneral ? "positions.banner.general" : "positions.banner.funcion") | translate }}</p>
			</div>
		</div>

		<div class="form-row">
			<div class="ff-field">
				<label>{{ "positions.col.codigo" | translate }}<span class="req">*</span></label>
				<div class="ff-box" [class.is-readonly]="!isNew">
					<input [(ngModel)]="codigo" [disabled]="!isNew" maxlength="50" [placeholder]="'positions.dialog.codigoPlaceholder' | translate" />
				</div>
				<small class="ff-hint" *ngIf="!isNew">{{ "positions.editor.codigoInmutable" | translate }}</small>
			</div>

			<div class="ff-field grow">
				<label>{{ "positions.col.descripcion" | translate }}<span class="req">*</span></label>
				<div class="ff-box">
					<input [(ngModel)]="description" maxlength="255" [placeholder]="'positions.dialog.descripcionPlaceholder' | translate" />
				</div>
			</div>
		</div>

		<div class="form-row" *ngIf="!isGeneral">
			<app-ds-select
				class="funcion-select"
				[label]="'positions.editor.funcion' | translate"
				[(ngModel)]="funcionAgregada"
				[options]="data.funciones"
				[optionLabel]="funcionLabelOf"
				[required]="true"
				[hint]="'positions.funcionReadonly' | translate"
			></app-ds-select>
		</div>

		<div class="form-row" *ngIf="!isNew">
			<app-ds-toggle
				[(ngModel)]="activo"
				[label]="'positions.editor.activo' | translate"
			></app-ds-toggle>
		</div>
	</div>

	<!-- Pie -->
	<div class="ds-dialog__footer">
		<button type="button" class="btn btn-ghost" (click)="close()" [disabled]="isSaving">{{ "common.cancel" | translate }}</button>
		<button type="button" class="btn btn-primary" (click)="save()" [disabled]="!canSave || isSaving">
			<span *ngIf="!isSaving">{{ (isNew ? "common.create" : "common.save") | translate }}</span>
			<span *ngIf="isSaving">{{ "common.saving" | translate }}…</span>
		</button>
	</div>
</div>
